/**
 * NEX-1164 — which 401/403 answers mean "the session is gone" (the four transport modules retry
 * once with a forced token refresh, then `redirectToLogin()`), as opposed to a domain refusal the
 * calling page has to show.
 *
 * Read off nexvia-api-web: `auth.middleware.ts` answers 401 `AUTH_UNAUTHORIZED` /
 * `AUTH_EMAIL_NOT_VERIFIED` and, for an expired or invalid Firebase token, 403 `AUTH_FORBIDDEN`.
 * Every other 403 the panel can get is a domain answer — `require-storage-profile.helper.ts`'s
 * `STORAGE_ROLE_REQUIRED` / `STORAGE_NOT_APPROVED` (the inbox refuses incomplete, rejected and
 * suspended accounts), `STORAGE_UNAUTHORIZED_VIEW_REQUEST`. Treating those as an expired session
 * sent a freshly registered (`incomplete`) account into a `/login` ↔ `/solicitudes` reload loop.
 *
 * A 403 with no code at all (a non-JSON body, an old handler) keeps the previous behavior and
 * counts as an auth failure; a 401 always does.
 */
export function isAuthFailure(status: number, body: unknown): boolean {
  if (status === 401) return true;
  if (status !== 403) return false;
  const code = body && typeof body === 'object' ? (body as Record<string, unknown>).code : undefined;
  return typeof code !== 'string' || code.startsWith('AUTH_');
}
